import { useTranslation } from '../../../../features/i18n/infra/useTranslation';
import countries from '../../../../public/locales/countries.json';

export const usePhoneRules = () => {
  const { t } = useTranslation();
  return {
    required: t('REQUIRED_PHONE'),
    minLength: {
      value: countries[process.env.NEXT_PUBLIC_COUNTRY_ID]?.phone_length,
      message: t('ERROR_INVALID_PHONE'),
    },
    maxLength: {
      value: countries[process.env.NEXT_PUBLIC_COUNTRY_ID]?.phone_length,
      message: t('ERROR_INVALID_PHONE'),
    },
    pattern: {
      value: /^\d+$/,
      message: t('ERROR_INVALID_PHONE'),
    },
  };
};
